import { render, staticRenderFns } from "./PackingTaskTable.vue?vue&type=template&id=7048998a"
import script from "./PackingTaskTable.vue?vue&type=script&lang=js"
export * from "./PackingTaskTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports